module.exports = __webpack_public_path__ + "img/open.cfa1dfff.png";